// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ypRaa","buttons":"styles_buttons__2Vbh6"};